import React from 'react';
import PropTypes from 'prop-types';

import { translate } from '../Services/translation';

const EstimatedOfferCard = ({
  title,
  supportDiscount,
  price,
  noOfferTitle,
  noOfferText,
  offerIsAvailable,
}) => {
  if (!offerIsAvailable || !price)
    return (
      <>
        <section className="estimated-offer-card">
          <div className="estimated-offer-card__title">{noOfferTitle}</div>
          <div className="estimated-offer-card__text">{noOfferText}</div>
        </section>
      </>
    );
  else {
    return (
      <>
        <section className="estimated-offer-card">
          <div className="estimated-offer-card__title">{title}</div>
          <div className="estimated-offer-card__item">
            <span>{translate('solcellepanel.estimated.offer.price')}</span>
            <span>
              {price} {translate('solcellepanel.estimated.general.currency')}
            </span>
          </div>
          <div className="estimated-offer-card__item">
            <span>
              {translate('solcellepanel.estimated.offer.supportdiscounttitle')}
            </span>
            <span>
              {supportDiscount}{' '}
              {translate('solcellepanel.estimated.general.currency')}
            </span>
          </div>

          <div className="estimated-offer-card__total">
            <span>{translate('solcellepanel.estimated.offer.totaltitle')}</span>
            <span>
              {price - supportDiscount}{' '}
              {translate('solcellepanel.estimated.general.currency')}
            </span>
          </div>
        </section>
      </>
    );
  }
};

export default EstimatedOfferCard;

EstimatedOfferCard.propTypes = {
  title: PropTypes.string,
  supportDiscount: PropTypes.number,
  price: PropTypes.number,
  noOfferTitle: PropTypes.string,
  noOfferText: PropTypes.string,
  offerIsAvailable: PropTypes.bool,
};
